import styled from 'styled-components';

export const DropPointtxtPara = styled.p(
  props => `
  color:#777777;
  font-size:${props.theme.font.base};
  line-height:1.6em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;

`,
);

export const ActivecardLayoutDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  width:100%;
  background-color:${props.theme.colors.white.base};
  border-radius:${props.theme.misc.borderRadius.custom(4)};
  margin-top: 0.8rem;
`,
);

export const ActivepcardInnerLayoutDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  width:100%;
  background-color:${props.theme.colors.white.base};
  border-radius:${props.theme.misc.borderRadius.custom(4)};
  padding: 1.8rem 2rem 1.5rem;
`,
);

export const AlerttextDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  width:100%;
  flex-direction:column;
  font-size:${props.theme.font.base};
  color:${props.theme.colors.red.base};
  align-items:flex-end;
  font-weight:bold;
  position: relative;
  right: 2rem;
  
`,
);

export const LayoutFirstDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:35%;

`,
);

export const LayoutSecondDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:30%;

`,
);

export const LayoutThirdDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:35%;

`,
);

export const BusBoldtxtPara = styled.p(
  props => `

  padding-bottom:0.3rem;
  font-weight: bold;
  font-size:${props.theme.font.custom(20)};
  font-family:${props.theme.font.fontFamily};
  display:flex;
  align-items:center;
`,
);

export const AdImg = styled.img(
  props => `
  margin-right:5px;
  height:${props.height};
  width:${props.width};
`,
);

export const BusNormaltxtPara = styled.p(
  props => `
  color: ${props.seatsAvailable <= 15 ? '#FAA243' : '#777777'};
  font-weight: ${props.seatsAvailable <= 15 ? 700 : 500};
  font-size:${props.theme.font.base};
  line-height:1.6em;
   display: -webkit-box;
   -webkit-box-orient: vertical;
   -webkit-line-clamp: 2;
   overflow: hidden;
`,
);

export const ArrivalDatetxtPara = styled.p(
  props => `
  color:#777777;
  font-size:${props.theme.font.base};
  line-height:1.6em;
  position: absolute;
  top: -1.7rem;
`,
);

export const StrikedAmountPara = styled.p(
  props => `
  color:#777777;
  font-size:${props.theme.font.base};
  line-height:1.6em;
  text-decoration: line-through;
  align-items: flex-end;
  display: flex;
  flex-direction: column;
`,
);

export const BusReviewOuterDiv = styled.p(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction:row;
  padding-top:${props.theme.spacing.large};
  align-items: center;

`,
);

export const BusReviewHighRatingSpan = styled.span(
  props => `
  display:flex;
  flex-wrap: wrap;
  border:1px solid ;
  padding-right:${props.theme.spacing.custom(6)};
  padding-left:${props.theme.spacing.custom(6)};
  color:${props.theme.colors.white.base};
  border-radius:${props.theme.misc.borderRadius.custom(3)};
  font-size:${props.theme.font.custom(11)};

`,
);

export const BusReviewLowRatingSpan = styled.span(
  props => `
  display:flex;
  flex-wrap: wrap;
  border:1px solid #79d148;
  background-color:${props.theme.colors.green.bgGreen};
  padding-right:${props.theme.spacing.custom(6)};
  padding-left:${props.theme.spacing.custom(6)};
  color:${props.theme.colors.red.base};
  border-radius:${props.theme.misc.borderRadius.custom(3)};
  font-size:${props.theme.font.custom(11)};

`,
);

export const BusReviewAverageRatingSpan = styled.span(
  props => `
  display:flex;
  flex-wrap: wrap;
  border:1px solid #79d148;
  background-color:${props.theme.colors.green.bgGreen};
  padding-right:${props.theme.spacing.custom(6)};
  padding-left:${props.theme.spacing.custom(6)};
  color:${props.theme.colors.yellow.cYellow};
  border-radius:${props.theme.misc.borderRadius.custom(3)};
  font-size:${props.theme.font.custom(11)};

`,
);

export const NumbersBoldSpan = styled.span(
  props => `
  display:flex;
  font-weight:bold;

`,
);

export const ReviewDividerSpan = styled.span(
  props => `
  display:flex;
  flex-wrap: wrap;
  border-right:1px solid grey;
  margin-right:${props.theme.spacing.custom(6)};
  margin-left:${props.theme.spacing.custom(8)};
  height:22px;
`,
);

export const ReviewNumberSpan = styled.span(
  props => `
  display:flex;
  flex-wrap: wrap;
  font-size:${props.theme.font.base};
  color:#777777;

`,
);
export const TotalSeatsPara = styled.p(
  props => `
  padding-top:${props.theme.spacing.custom(2)};
  padding-bottom:${props.theme.spacing.custom(13)};
  color:#777777;
  font-size:${props.theme.font.base};
  line-height:1.6em;
  display: flex;
  flex-direction: row;
  span { padding-right: 0.5rem}
`,
);

export const TotalDurationWrapperDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:33%;

`,
);

export const DepartureWrapperDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:33%;
`,
);

export const ArrivalWrapperDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:33%;
  position:relative;
  padding-left: 2rem;
`,
);

export const DurationDiv = styled.span(
  props => `
  display:flex;
  flex-wrap: wrap;
  font-size:${props.theme.font.base};
  color:#777777;
  padding-top:${props.theme.spacing.small}
  align-items:center;
  flex-direction: column;



`,
);

export const JourneyDurationDiv = styled.div(
  props => `
  width:100%;
  display: inline-flex;
  padding: 0.3rem;
  position: relative;

`,
);

export const StartSpan = styled.span(
  props => `
  display: inline-flex;
  width: 5px;
  height: 6px;
  background-color: #eff3f8;;
  border-radius: 50%;

  position: absolute;
  top: 1px;

`,
);

export const DistanceSpan = styled.span(
  props => `
    display: inline-flex;
    border: 0.5px solid #eff3f8;;
    width: 100%;
    margin-bottom: 2px;

  `,
);

export const StopSpan = styled.span(
  props => `
    display: inline-flex;
    width: 5px;
    height: 6px;
    background-color: #eff3f8;;
    border-radius: 50%;
    position: absolute;
    top: 1px;
    right:0px;
  `,
);

export const NumberofStopDiv = styled.span(
  props => `
    display:flex;
  flex-wrap: wrap;
  font-size:${props.theme.font.base};
  color:#777777;
  padding-bottom:${props.theme.spacing.base}
  align-items:center;
  flex-direction: column;
  `,
);

export const BusTimingWrapNewDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
  `,
);

export const BusBtnDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    padding-top: 0.6rem;
  `,
);

export const PayBtnWrapDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    justify-content: center;
    padding-left:${props.theme.spacing.small};
    padding-right:${props.theme.spacing.small};
    padding-top:${props.theme.spacing.custom(3)};
    padding-bottom:${props.theme.spacing.custom(3)};

  `,
);

export const PayTxtSpan = styled.span(
  props => `
      font-family:${props.theme.font.fontFamily};
      font-size:${props.theme.font.custom(14)};
      font-weight:bold;
  `,
);

export const BusPriceDetailsDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: row;

    justify-content: flex-end;
  `,
);

export const BusPriceDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    padding-right:${props.theme.spacing.xxlarge};
    align-items: flex-end;
  `,
);

export const PriceSeparationDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    

  `,
);

export const RupeeSpan = styled.span(
  props => `

    font-size:${props.theme.font.custom(20)};
    padding-right:${props.theme.spacing.small};
  `,
);

export const RupeetxtSpan = styled.span(
  props => `

    font-size:${props.theme.font.custom(20)};
    font-family:${props.theme.font.fontFamily};
    font-weight:bold;
  `,
);

export const BusDetailsDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    min-height: 8.5rem;
  `,
);

export const OfferDetailsDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    background: rgba(255,194,74,0.1);
    margin-top:${props.theme.spacing.large};
    border-radius: 3rem;
    padding-right: 0.8rem;
    align-items: center;



  `,
);
export const OfferTxt = styled.span`
  color: #846418;
  font-size: 0.9rem;
  padding-left: 0.5rem;
  font-weight: bold;
`;

export const AmminitiesLayoutDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    width:100%;
    background-color:${props.theme.colors.white.base};
    border-bottom-left-radius:${props.theme.misc.borderRadius.custom(4)};
    border-bottom-right-radius:${props.theme.misc.borderRadius.custom(4)};
    border-top: 1px solid #eff3f8;
    padding: 1rem 2rem;
    align-items: center;
    justify-content: space-between;

  `,
);

export const AmminitiesInnerLayoutDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `,
);

export const InnerContentLayoutDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    padding-right:${props.theme.spacing.xlarge};
    align-items: center;
    position: relative;
  `,
);

export const TextSpan = styled.span(
  props => `

    display:flex;
    flex-wrap: wrap;
    color:#647a97;
    font-size: 1.2rem;
    align-items:center;
    font-weight:medium;
    padding-left: 0.5rem;
  `,
);

export const BoadingElink = styled.a(
  props => `

    display:flex;
    flex-wrap: wrap;
    colors:${props.theme.colors.goBrand.blue};
    font-size: 1.2rem;
    padding-left: 2.5rem;
  `,
);

export const IconWrap = styled.div`
  padding-left: 1rem;
  cursor:pointer;
`;
export const TabsCardWrap = styled.section`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #eff3f8;
  padding: 1rem 2rem;
  width: 100%;
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 2rem 1.5rem;
`;
export const goSafeTag = styled.p`
  background: #e9f6ea;
  border-radius: 0.4rem;
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: row;
  margin-right: 0.5rem;
  span {
    color: black;
    font-size: 1.2rem;
    padding-left: 0.5rem;
  }
`;
export const SCText = styled.span`
  font-size: 1.4rem;
  padding-left: 0.5rem;
`;
export const SDTooltip = styled.span`
  width: 240px;
  border-radius: 1px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  font-size: 1.2rem;
  color: #777;
  padding: 0.5rem 1rem;
  position: absolute;
  top: 1.8rem;
  display: none;
`
export const SocialDistanceActive = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  &:hover ~ ${SDTooltip} {
    display: block
  }
`
export const GoSafePersuationTxt = styled.span`
  font-size: 1.4rem;
  padding-left: 1rem;
  color: #148730
`

